import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Table, Icon, Spin } from 'antd';
import moment from 'moment';
import { Modal } from '../../../../helpers/commonUi'
import nodataImg from "../../../../assets/images/createDelpoyIcon.svg";
import style from './list.module.sass';
import NewVersion from './NewVersion';
import Deployment from './Deployment';
import History from './History';
import { Http } from '../../../../helpers/axois';
import { DeploymentUpdateVerison } from '../../../../helpers/RxServices';
import { Button } from '../../../../helpers/commonUi';
import classNames from 'classnames';
import { useToast } from "../../../../helpers/commonFunction";
import NoData from '../../NoData'
import { useSelector } from 'react-redux';
import LiveDeployment from './LiveDeployment';
import ModalFooter from '../../../../helpers/commonUi/ModalFooter';
import SearchBar, { highlightMatch } from "../../../../helpers/SearchBar";

interface Props {
    appDetails?: any;
}
const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

const List: React.FC<Props> = (props) => {
    const appDetails = props.appDetails && props.appDetails[0];
    const appId = appDetails && appDetails.appId
    const [loading, SetLoading] = useState(true);
    const [list, setlist] = useState([]); //  previous version data
    const [modalVisible, setmodalVisible] = useState(false); // create new version modal
    const [deployModal, setdeployModal] = useState(false);  // open deploy modal
    const [version, setversion] = useState<any>({});  // save create new version from version modal
    const [deployData, setdeployData] = useState<any>({}); // save deploy data from modal
    const [livedeployData, setlivedeployData] = useState<any>({}); // save deploy data from modal
    const [historymodal, sethistorymodal] = useState(false) // open histroy modal
    const [liveDeploymodal, setliveDeploymodal] = useState(false) // open live deploy modal
    const [currentDeployTable, setcurrentDeployTable] = useState<any>(); /// current  deploy data from table row
    const [envList, setEnvList] = useState<any>([])
    const [error, setError] = useState<any>();
    const [aiAgents, setAIAgents] = useState<string[]>([]);
    const [isFormSelected, setIsFormSelected] = useState<boolean>(true);
    const [deploymentLoading, setDeploymentLoading] = useState(false)
    const { ErrorToast, SuccessToast } = useToast();
    const appInfo = useSelector((state: any) => state.apps.selectedApp)
    const orgId = useSelector((state: any) => state.org.selectedOrg.id)
    const appType = appInfo.type
    const [overrideFor, setOverrideFor] = useState<"prod" | "live" | null>(null)
    const [showOverrideModal,setShowOverrideModal]=useState(false)
    const [deployEnv, setDeployEnv] = useState<any>({})
    const [showProdConfirmationModal,setShowProdConfirmationModal]=useState(false)
    const [isLiveDeployment,setIsLiveDeployment]=useState(false)
    const [filteredData, setFilterData] = useState<any[]>([])
    const searchRef = useRef<{ clearSearch: () => void }>(null);
    const [searchValue, setSearchValue] = useState<string>("")

    useEffect(() => {
        Http.get(`org/${orgId}/environments`).subscribe((res: any) => {
            setEnvList(res);
        })
    }, [orgId, appType])

    useEffect(() => {
        Http.get(`org/${orgId}/apps/${appId}`).subscribe((res: any) => {
            {
                if (Array.isArray(res) && res.length) {
                    setAIAgents(res[0].ai_agents ?? [])
                }
            }
        })
    }, [orgId, appType])

    useEffect(() => {
        if (deployModal && deployData) {
            const envLists = envList.find((el: any) => el.id === deployData.envId)
            setDeployEnv({
                ...envLists,
                botHandle: deployData?.botHandle || null
            })
        } else if (liveDeploymodal && livedeployData) {
            const envLists = envList.find((el: any) => el.id === livedeployData.envId)
            setDeployEnv({
                ...envLists,
                botHandle: livedeployData?.botHandle || null
            })
        }
    }, [deployModal, liveDeploymodal, deployData, livedeployData])

    const currentAppBranch = useSelector((state: any) => {
        const selectedAppId = state.apps.selectedApp && state.apps.selectedApp.id
        return (state.apps.appBranch && state.apps.appBranch[selectedAppId]) || {}
    }, (left: any, right: any) => left.branchId === right.branchId)

    const orgPermissions: any = useSelector((state: any) => {
        return state.org.orgPermissions
    }, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))

    const appPermissions: any = useSelector((state: any) => {
        return state.apps.selectedApp.permissions
    }, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))

    const canCreateRelease = orgPermissions.includes('deploy.CreateRelease') || appPermissions.includes('deploy.CreateRelease')
    const canLiveDeploy = orgPermissions.includes('deploy.LiveDeploy') || appPermissions.includes('deploy.LiveDeploy')
    const canDeploy = orgPermissions.includes('deploy.Deploy') || appPermissions.includes('deploy.Deploy')

    const getVersion = useCallback(() => {
        searchRef.current?.clearSearch()
        const branchId = currentAppBranch && currentAppBranch.branchId
        if (appId) {
            Http.get(`version/${appId}?branchId=${branchId}`).subscribe((versionList: any) => {
                setlist(versionList)
                setFilterData(versionList)
                SetLoading(false);
            }, (err) => {
                setFilterData([])
                SetLoading(false);
            })
        }
    }, [appId, currentAppBranch])

    useEffect(() => {
        getVersion();
        SetLoading(true);
    }, [getVersion])

    useEffect(() => {
        if (!isFormSelected) {
            ErrorToast('Please select the reference to form or service')
        }
    }, [ErrorToast, isFormSelected])

    const createNewVersion = () => {
        setDeploymentLoading(true)
        const branchId = currentAppBranch && currentAppBranch.branchId
        setError(null);
        if (!version.versionTag) {
            ErrorToast('Please enter the versionTag')
            setDeploymentLoading(false)
            return 0;
        }
        if (!appDetails) {
            setDeploymentLoading(false)
            return 0;
        }
        const data = {
            ...version,
            cVersionTag: appDetails.versionTag,
            cVersionCode: appDetails.versionCode,
            branchId: branchId
        }
        Http.post(`version/${appDetails.appId}`, data).subscribe((res) => {
            SuccessToast('Version created successfully')
            getVersion();
            DeploymentUpdateVerison.sendMessage({
                message: 'versionCreated',
                data: {}
            });
            setmodalVisible(false);
            setDeploymentLoading(false)
        }, (err) => {
            if (err && err.message) {
                ErrorToast(err.message.replace("Bpmn", "solo"))
            } else {
                ErrorToast('Version creation failed')
            }
            setError(err);
            setDeploymentLoading(false)
        })
    }

    const deploy = async (checkDeploy = false) => {
        if (!deployData.envId) {
            ErrorToast('Please select the environment')
            return 0;
        }
        setDeploymentLoading(true)
        const data = {
            ...deployData,
            appId: appDetails.appId,
            versionId: currentDeployTable.version_id,
            aiAgents: aiAgents,
            genaiUrl: window.env?.GENAI_URL,
        }

        if (checkDeploy) {
            try {
                const res: any = await Http.post('check-bot-deployment', {
                    envId: deployData.envId,
                    appId,
                    botHandle: deployData.botHandle,
                    branchId: currentAppBranch && currentAppBranch.branchId,
                    mode: "prod",
                }).toPromise()
                if(res.conflict) {
                    setdeployModal(false)
                    setShowOverrideModal(true)
                    setOverrideFor("prod")
                    setDeploymentLoading(false)
                    setIsLiveDeployment(false)
                    return
                }else{
                    const env = envList.find((e: any) => e?.id === deployData?.envId);
                    if (env?.type === "production") {
                        setDeploymentLoading(false)
                        setIsLiveDeployment(false)
                        setdeployModal(false)
                        setShowProdConfirmationModal(true)
                    return
                    }
                }
            } catch(err) {
              setDeploymentLoading(false)
            }
        }

        Http.post('deployment', data).subscribe((res: any) => {
            SuccessToast('Deployment successful')
            getVersion()
            setdeployModal(false);
            setShowOverrideModal(false);
            setOverrideFor(null)
            setcurrentDeployTable(null);
            setdeployData({});
            setDeploymentLoading(false)
            setShowProdConfirmationModal(false);
            setIsLiveDeployment(false)
        }, (err) => {
            if (err && err.message) {
                ErrorToast(err.message.replace("bpmn", "solo"), false)
            } else {
                ErrorToast('Deployment failed')
            }
            setdeployModal(false);
            setOverrideFor(null)
            setShowOverrideModal(false);
            setcurrentDeployTable(null);
            setdeployData({});
            setDeploymentLoading(false)
            setShowProdConfirmationModal(false);
            setIsLiveDeployment(false)
        });
    }

    const liveDeploy = async (checkDeploy = false) => {
        if (!livedeployData.envId) {
            ErrorToast('Please select the environment')
            return 0;
        }
        if(checkDeploy) {
            const res: any = await Http.post('check-bot-deployment', {
                envId: livedeployData.envId,
                appId,
                branchId: currentAppBranch && currentAppBranch.branchId,
                mode: "live",
                botHandle: livedeployData.botHandle,
            }).toPromise()
            if(res.conflict) {
                setOverrideFor("live")
                setShowOverrideModal(true);
                setliveDeploymodal(false)
                setDeploymentLoading(false)
                setIsLiveDeployment(true)
                return
            }else{
                const env = envList.find((e: any) => e?.id === livedeployData?.envId);
                if (env?.type === "production") {
                    setDeploymentLoading(false)
                    setIsLiveDeployment(true)
                    setliveDeploymodal(false)
                    setShowProdConfirmationModal(true)
                    return
                }
            }
        }
        setDeploymentLoading(true)
        const data = {
            ...livedeployData,
            appId: appDetails.appId,
            'versionTag': appDetails.versionTag,
            'versionId': appDetails.version_id,
            'host': window.location.origin,
            aiAgents: aiAgents,
            genaiUrl: window.env?.GENAI_URL,
        }
        Http.post('livedeployment', data).subscribe((res: any) => {
            SuccessToast('Deployment successful')
            setliveDeploymodal(false);
            setlivedeployData({});
            setOverrideFor(null)
            setShowOverrideModal(false);
            setDeploymentLoading(false)
            setShowProdConfirmationModal(false);
        }, (err) => {
            if (err && err.message) {
                ErrorToast(err.message.replace("bpmn", "Journey"))
            } else {
                ErrorToast('Deployment failed')
            }
            setliveDeploymodal(false);
            setOverrideFor(null)
            setShowOverrideModal(false);
            setlivedeployData({});
            setDeploymentLoading(false)
            setShowProdConfirmationModal(false);
        })
    }

    const columns = [
        {
            title: 'Version Code',
            dataIndex: 'version_code',
            key: 'vc',
            render: (value: string)=>{
                const formattedValue = highlightMatch(value, searchValue)
                return <span data-test-id="version_code" >{formattedValue}</span>
            }
        },
        {
            title: 'Version Tag',
            dataIndex: 'version_tag',
            key: 'vt',
            render: (value: string)=>{
                const formattedValue = highlightMatch(value, searchValue)
                return <span data-test-id="version_tag" >{formattedValue}</span>
            }
        },
        {
            title: 'Release Notes',
            dataIndex: 'release_note',
            key: 'rn',
            render: (value: string)=>{
                const formattedValue = highlightMatch(value, searchValue)
                return <span data-test-id="release_notes" >{formattedValue}</span>
            }
        },
        {
            title: 'Recently Deployed',
            dataIndex: 'envType',
            key: 'rd',
            render: (text: any, record: any) => {
                const formattedValue = record?.deploy?.envType ? highlightMatch(record?.deploy?.envType.toUpperCase(), searchValue) : null
                return (
                    (record.deploy && record.deploy.envType) ? (
                        <div data-test-id="recently_deployed" className={style.recDeploy}>
                            <div className={classNames({
                                [style.depStatusStag]: (record.deploy.envType === 'staging'),
                                [style.depStatusTesting]: (record.deploy.envType === 'testing'),
                                [style.depStatusProd]: (record.deploy.envType === 'production'),
                            })}>
                                {formattedValue}
                            </div>
                        </div>
                    ) : null
                )
            },
        },
        {
            title: 'Deployed Time',
            dataIndex: 'deployedTime',
            key: 'deployedtime',
            render: (text: any, record: any) => {
                const formattedValue = record?.deploy?.deployedTime && highlightMatch(moment.utc(record?.deploy?.deployedTime).fromNow(), searchValue)
                return (
                    <span data-test-id="deployed_time">{formattedValue}</span>
                )
            }
        },
        {
            title: 'Deployed By',
            dataIndex: 'depolyedBy',
            key: 'depolyedby',
            render: (text: any, record: any) => {
                const formattedValue = record?.deploy?.depolyedBy ? highlightMatch(record.deploy.depolyedBy, searchValue) : ""
                return (
                    <span data-test-id="deployed_time">{formattedValue}</span>
                )
            }
        },
        {
            title: '',
            dataIndex: '',
            key: 'button',
            render: (text: any, record: any) => canDeploy ?
                <div data-test-id="deploy_button" className={style.deployButton} onClick={(e: any) => {
                    e.stopPropagation();
                    if (envList.length > 0) {
                        setcurrentDeployTable(record);
                        setdeployModal(true)
                    } else {
                        ErrorToast('No environments available to deploy')
                    }
                }}>
                    DEPLOY
                </div> : null,
        }
    ]

    return (
        <div className='viewWrapper'>
            {
                (!loading && list.length > 0) ?
                    <React.Fragment>
                        <div className={"row " + style.versionButtons}>
                            {
                                canCreateRelease && <Button dataTestId="create_release" onClick={() => setmodalVisible(true)} size='small' color='primary'>Create Release</Button>
                            }
                            
                            <div className='flex gap-2 items-center'>
                                <SearchBar
                                    ref={searchRef}
                                    data={list}
                                    columns={columns}
                                    onFilter={(filteredData ) => {
                                        setFilterData(filteredData)
                                    }}
                                    onSearchTermChange={ (searchValue: string)=>{ setSearchValue(searchValue) } }
                                />
                                {
                                    canLiveDeploy && <Button dataTestId="live_deploy" size='small' onClick={() => setliveDeploymodal(true)} color='primary' className={style.liveDeploy}>Live Deploy</Button>
                                }
                            </div>
                        </div>
                        {/* <div className={"row " + style.box} >
                            <div className={style.main}>
                                <div className={style.textDiv}>
                                    <span className={style.header}> Version code</span>
                                    <span className={style.subheader}> {appDetails && appDetails.versionCode} </span>
                                </div>
                                <div className={style.textDiv}>
                                    <span className={style.header}> Version Tag</span>
                                    <span className={style.subheader}> {appDetails && appDetails.versionTag} </span>
                                </div>
                            </div>
                            <div className={style.main}>
                                <Button onClick={() => setmodalVisible(true)} size='small' color='primary'>CREATE NEW VERSION</Button>
                            </div>
                        </div>
                        <div className={style.Table}>
                            <h4 className={style.preheader}>Live Version</h4>
                            <div className={"row " + style.box} >
                                <div className={style.main}>
                                    <div className={style.textDiv}>
                                        <span className={style.header}> Version code</span>
                                        <span className={style.subheader}> {appDetails && appDetails.versionCode} </span>
                                    </div>
                                    <div className={style.textDiv}>
                                        <span className={style.header}> Version Tag</span>
                                        <span className={style.subheader}> {appDetails && appDetails.versionTag} </span>
                                    </div>
                                </div>
                                <div className={style.main}>
                                    <Button size='small' onClick={() => setliveDeploymodal(true)} color='primary' className={style.liveDeploy}>Deploy</Button>
                                </div>
                            </div>
                        </div> */}
                        <div className={"row " + style.Table}>
                            <h4 className={style.preheader}>Versions</h4>
                            <Table data-test-id="table_row" rowKey="version_id" columns={columns}
                                pagination={false}
                                // rowSelection={{ 
                                //   type : 'checkbox',
                                //   onChange: (selectedRowKeys, selectedRows) => {
                                //   }
                                // }}
                                // scroll={{ y: 300 }}
                                scroll={{ y: 'calc(100vh - 240px)' }}
                                onRow={(record, rowIndex) => {
                                    return {
                                        'data-test-id': 'deployment_table_row_' + record.key,
                                        onClick: (e) => {
                                            setcurrentDeployTable(record);
                                            sethistorymodal(true);
                                        }
                                    }
                                }}
                                className={"override-table-container"} style={{ width: '100%' }} dataSource={filteredData} />
                        </div>
                    </React.Fragment>
                    :
                    (loading)
                        ?
                        <div className={style.loadingSpinner + " row"}>
                            <Spin indicator={antIcon} style={{ color: '#15808C' }} />
                        </div>
                        :
                        <NoData
                            data-test-id="btn"
                            image={nodataImg}
                            header='Create Deployment'
                            content='Create deployment for your apps'
                            // buttonText='Create new version'
                            buttonCallback={() => canCreateRelease ? setmodalVisible(true) : ErrorToast('You are not authorized to create deployment versions')}
                        />
            }
            <Modal
                dataTestId="cnv"
                id='cnv'
                title='CREATE NEW VERSION'
                visible={modalVisible}
                onCancel={() => {
                    setError(null);
                    setmodalVisible(false)
                }}
                loading={deploymentLoading}
                unmountOnCancel={true}
                footer={{
                    enable: true,
                    okText: 'CREATE',
                    cancelText: "CANCEL",
                    onOk: createNewVersion,
                    disableOkButton: deploymentLoading || !isFormSelected,
                    disableOkButtonClass: "modal_footer_loading"
                }}
            // mode='EditCreate'
            >
                {
                    modalVisible &&
                    <NewVersion
                        data-test-id="new_version"
                        error={error}
                        setIsFormSelected={setIsFormSelected}
                        appDetails={appDetails} data={(key: any, value: any) => {
                            setError(null); setversion({
                                ...version,
                                [key]: value
                            })
                        }} />
                }
            </Modal>
            <Modal
                id='deployemnthistory'
                dataTestId="deployment_history"
                title='DEPLOYMENT HISTORY'
                visible={historymodal}
                onCancel={() => {
                    setcurrentDeployTable(null);
                    sethistorymodal(false)
                }}
                width='600px'
                unmountOnCancel={true}
                footer={{
                    enable: false
                }}
            // mode='EditCreate'
            >
                {historymodal && currentDeployTable && <History currentDeploy={{ ...currentDeployTable, orgId: appDetails.orgId }} />}
            </Modal>
            <Modal
                id="livedeploy"
                dataTestId="live_deploy"
                title={"Live Deployment"}
                visible={liveDeploymodal}
                onCancel={() => {
                    setliveDeploymodal(false);
                }}
                loading={deploymentLoading}
                unmountOnCancel={true}
                footer={{
                    enable: true,
                    okText: 'DEPLOY',
                    cancelText: "CANCEL",
                    onOk: () => {
                        const env = envList.find((e: any) => e?.id === livedeployData?.envId);
                        if (env?.type === "production" && !deployEnv?.botHandle && appType != "a8chat") {
                            setIsLiveDeployment(true)
                            setliveDeploymodal(false)
                            setShowProdConfirmationModal(true)
                            return
                        }
                        liveDeploy(deployEnv?.botHandle && appType === "a8chat")
                    },
                    disableOkButton: appType === "a8chat" ? !livedeployData.botHandle : !isFormSelected,
                    disableOkButtonClass: "modal_footer_loading"
                }}
            >
                {liveDeploymodal && <LiveDeployment envList={envList} appType={appType} setIsFormSelected={setIsFormSelected} data={(key: any, value: any) => setlivedeployData({
                    ...livedeployData,
                    [key]: value
                })} currentDeploy={{ orgId: appDetails.orgId }} appDetails={appDetails}></LiveDeployment>}
            </Modal>
            <Modal
                id='deploy'
                dataTestId="deploy"
                title='DEPLOYMENT'
                visible={deployModal}
                onCancel={() => {
                    setcurrentDeployTable(null);
                    setdeployModal(false)
                }}
                loading={deploymentLoading}
                unmountOnCancel={true}
                footer={{
                    enable: true,
                    okText: 'DEPLOY',
                    cancelText: "CANCEL",
                    onOk: () =>{ 
                        const env = envList.find((e: any) => e?.id === deployData?.envId);
                        if (env?.type === "production" && (!deployEnv?.botHandle && appType != "a8chat")) {
                            setIsLiveDeployment(false)
                            setdeployModal(false)
                            setShowProdConfirmationModal(true)
                            return
                        }
                        deploy(deployEnv?.botHandle && appType === "a8chat")},
                    disableOkButtonClass: "modal_footer_loading",
                    disableOkButton: appType === "a8chat" ? !deployData?.botHandle : !isFormSelected
                }}
            // mode='EditCreate'
            >
                {
                    currentDeployTable && <Deployment
                        appType={appType}
                        envList={envList}
                        currentDeploy={{ ...currentDeployTable, orgId: appDetails.orgId }}
                        data={(key: any, value: any) => setdeployData({
                            ...deployData,
                            [key]: value
                        })} />
                }
            </Modal>

            <Modal
                id='override'
                dataTestId="override"
                title='DEPLOY'
                visible={showOverrideModal}
                onCancel={() => {
                    setOverrideFor(null)
                    setShowOverrideModal(false);
                    setDeploymentLoading(false)
                }}
                unmountOnCancel={true}
                footer={{
                    enable: true,
                    okText: 'DEPLOY',
                    cancelText: "CANCEL",
                    onOk:()=> {
                        const env = envList.find((e: any) => overrideFor === "live" ? e?.id === livedeployData?.envId : e?.id === deployData?.envId);
                        if (env?.type === "production") {
                            setShowOverrideModal(false)
                            setShowProdConfirmationModal(true)
                            return
                        }
                        overrideFor === "live" ? liveDeploy() : deploy()
                    },
                }}
            >
                <div style={{
                    color: '#393939',
                    fontSize: 15,
                    fontWeight: 500,
                    padding: '18px 14px',
                }}>
                    <p>The <span style={{
                        borderRadius: 3,
                        border: '1px solid #0B922B',
                        background: '#F2FFF8',
                        color: '#0B922B',
                        fontSize: 13,
                        fontWeight: 400,
                        padding: '2px 6px',
                    }}>{deployEnv?.botHandle}</span> bot is used in another app or branch. Would you like to override and proceed with the deployment?</p>
                </div>
            </Modal>
            <Modal
                id='deploy_confirmation'
                dataTestId="deploy_confirmation"
                title='CONFIRM DEPLOYMENT'
                visible={showProdConfirmationModal}
                onCancel={() => {
                    setShowProdConfirmationModal(false);
                    setcurrentDeployTable(null);
                }}
                loading={deploymentLoading}
                unmountOnCancel={true}
                footer={{
                    enable: false,
                }}
            >
                <>
                    <div style={{ padding: "16px 35px 40px 14px", fontSize: 16, color: "#292D32" }}>You are about to deploy to production. 
                        <div> <span style={{fontWeight:600}}>Caution: </span>This action cannot be undone. Continue?</div> </div>
                    <ModalFooter
                        okCallback={() => {

                            if (isLiveDeployment) {
                                liveDeploy()
                            } else {
                                deploy()
                            }


                        }}
                        cancelCallback={() => { setcurrentDeployTable(null); setdeployModal(false); setShowProdConfirmationModal(false); setIsLiveDeployment(false) }}
                        okClassName='modal_footer_loading'
                        okText='CONFIRM'
                        cancelText="CANCEL"
                        disableOkButton={deploymentLoading}
                    />
                </>
            </Modal>
        </div>
    );
}

export default List;
